import style from './list-select.scss';
import siblingsSwitcher from 'Assets/js/siblings-switcher-behavior';

const script = () => {
  siblingsSwitcher({
    cssClass: '.ListSelect',
    cssClassDefault: 'ListSelect',
    titleLabelTag: 'h2',
    selectorList: '.ListSelect-list',
    selectorItem: '.ListSelect-item > input + label',
    selectorActive: '.ListSelect-item > input:checked + label',
    defaultSelect: true,
    amountInformations: (typeof drupalSettings !== 'undefined' && drupalSettings.adt_job?.jobs_per_domain) ?
      drupalSettings.adt_job.jobs_per_domain :
      (typeof amountInformationsByRegiments !== 'undefined' ? amountInformationsByRegiments : {}),
  });

  // drupal filter
  siblingsSwitcher({
    cssClass: '.view-regiment-list [data-drupal-selector="edit-weapon-type"]',
    cssClassDefault: 'ListSelect',
    titleLabelTag: 'h2',
    selectorList: '.fieldset-wrapper > .form-radios > .form-radios',
    selectorItem: '.form-type-radio input + label',
    selectorActive: '.form-type-radio input:checked + label',
    defaultSelect: true,
    amountInformations: (typeof drupalSettings !== 'undefined' && drupalSettings.adt_regiment?.regiments_per_weapon_type) ?
      drupalSettings.adt_regiment.regiments_per_weapon_type :
      (typeof amountInformationsByRegiments !== 'undefined' ? amountInformationsByRegiments : {}),
  });
  siblingsSwitcher({
    cssClass: '.view-regiment-list [data-drupal-selector="edit-region"]',
    cssClassDefault: 'ListSelect',
    titleLabelTag: 'h2',
    selectorList: '.fieldset-wrapper > .form-radios > .form-radios',
    selectorItem: '.form-type-radio input + label',
    selectorActive: '.form-type-radio input:checked + label',
    defaultSelect: true,
    amountInformations: (typeof drupalSettings !== 'undefined' && drupalSettings.adt_regiment?.regiments_per_region) ?
      drupalSettings.adt_regiment.regiments_per_region :
      (typeof amountInformationsByRegiments !== 'undefined' ? amountInformationsByRegiments : {}),
  });
};

export {
  style,
  script,
};
